import { useEffect, useRef, useState } from 'preact/hooks';
import { ExtendedReviewsWidgetSettings } from 'types/settings';

import { useSettings } from 'components/SettingsProvider';

export function PrivacyPolicyIFrame() {
  const { utils } = useSettings<ExtendedReviewsWidgetSettings>();
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [loaded, setLoaded] = useState(false);

  const { privacyPolicy } = utils;

  useEffect(() => {
    const iframeCurrent = iframeRef.current;

    if (loaded && iframeCurrent && iframeCurrent.contentWindow) {
      const height =
        iframeCurrent.contentWindow.document.documentElement.scrollHeight;

      iframeCurrent.height = `${height}`;
    }
  }, [loaded]);

  return (
    <iframe
      ref={iframeRef}
      frameBorder="0"
      height="100%"
      width="100%"
      srcDoc={privacyPolicy}
      onLoad={() => setLoaded(true)}
    />
  );
}
